var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6426 0.423828C8.1812 0.423828 9.73083 2.22309 11.0273 4.16748C11.181 4.39845 11.181 4.69909 11.0273 4.93006C9.73083 6.87445 8.1812 8.67385 5.6426 8.67385C3.104 8.67385 1.55437 6.87459 0.257878 4.9302C0.104145 4.6992 0.104145 4.39848 0.257878 4.16748C1.55437 2.22309 3.104 0.423828 5.6426 0.423828ZM1.6617 4.54794C3.04413 6.51984 4.18284 7.29795 5.64179 7.29795C7.10074 7.29795 8.23945 6.5199 9.62188 4.54794C8.23945 2.57605 7.10074 1.79793 5.64179 1.79793C4.18284 1.79793 3.04413 2.57598 1.6617 4.54794Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64258 3.17383C4.88319 3.17383 4.26758 3.78944 4.26758 4.54883C4.26758 5.30823 4.88319 5.92384 5.64258 5.92384C6.40198 5.92384 7.01759 5.30823 7.01759 4.54883C7.01656 3.78986 6.40155 3.17485 5.64258 3.17383V3.17383Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/views-icon.d600432a8931b6125f6ed6148d66794d.svg";
export { ForwardRef as ReactComponent };